var map = {
	"./translation-1-de_DE.js": 78,
	"./translation-2-fr_FR.js": 79,
	"./translation-3-nl_NL.js": 80,
	"./translation-4-de_AT.js": 81,
	"./translation-5-de_CH.js": 82,
	"./translation-5-fr_CH.js": 83,
	"./translation-6-fr_BE.js": 84,
	"./translation-6-nl_BE.js": 85,
	"./translation-7-it_IT.js": 86,
	"./translation-8-de_DE.js": 87
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54;



/*****************
 ** WEBPACK FOOTER
 ** ./generated ../~/promise-loader?global!^\.\/translation\-.*\.js$
 ** module id = 54
 ** module chunks = 20 21 22
 **/